module.exports = __webpack_public_path__ + "img/08be429818004b55a66fa2884d198bd3.08be9ded.jpg";